<ng-container *ngIf="defaultFilter">
  <atm-filter-editor-input
    [data]="defaultFilter"
    (setFilter)="setFilter($event)"
    (filtering)="search()"
    [quickSearch]="true"
  ></atm-filter-editor-input>
  <button
    mat-icon-button
    [disabled]="!newFilterSetted"
    type="button"
    (click)="search()"
  >
    <mat-icon>search</mat-icon>
  </button>
</ng-container>
<button
  mat-icon-button
  type="button"
  (click)="add()"
  matTooltip="Add a new filter"
>
  <mat-icon>filter_list</mat-icon>
</button>
<mat-chip-list>
  <mat-chip
    *ngFor="let filter of filterList; let i = index"
    (click)="editAt(i)"
    (removed)="removeAt(i)"
    [removable]="filter.filter.removable"
  >
    {{ filter | filterLabel }}
    <button matChipRemove *ngIf="filter.filter.removable">
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip>
</mat-chip-list>
